
<dashboardnav>
    <cradua-seismicswathno
    [seismicswathnos]="seismicswathnos$ | async"
    (seismicswathno)="onSubmitSeismicSwathNo($event)"
    (deleteSeismicSwathNoEvent)="onDeleteSeismicSwathNo($event)"
    *ngIf="(isLoadingSeismicSwathNo$ | async ) === false"
    >
  </cradua-seismicswathno>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingSeismicSwathNo$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
